/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Chat_TInputs */

const en_mk_tut_chat_t = /** @type {(inputs: Mk_Tut_Chat_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat and mentioning agents`)
};

const id_mk_tut_chat_t = /** @type {(inputs: Mk_Tut_Chat_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim dan menyebut agen`)
};

/**
* | output |
* | --- |
* | "Team chat and mentioning agents" |
*
* @param {Mk_Tut_Chat_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chat_t = /** @type {((inputs?: Mk_Tut_Chat_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Chat_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chat_t(inputs)
	return en_mk_tut_chat_t(inputs)
});